// src/redux-saga/redux/sportsBanner/fifaSlice.js

// Action Types
export const FETCH_FIFA_MATCHES_REQUEST = "fifa/FETCH_FIFA_MATCHES_REQUEST";
export const FETCH_FIFA_MATCHES_SUCCESS = "fifa/FETCH_FIFA_MATCHES_SUCCESS";
export const FETCH_FIFA_MATCHES_FAILURE = "fifa/FETCH_FIFA_MATCHES_FAILURE";

// Action Creators
export const fetchFifaMatchesRequest = (limit = 10, page = 1) => ({
  type: FETCH_FIFA_MATCHES_REQUEST,
  payload: { limit, page },
});

export const fetchFifaMatchesSuccess = (matches) => ({
  type: FETCH_FIFA_MATCHES_SUCCESS,
  payload: matches, // Receives the cleanly extracted array sent from the Saga
});

export const fetchFifaMatchesFailure = (error) => ({
  type: FETCH_FIFA_MATCHES_FAILURE,
  payload: error,
});

// Initial State
const initialState = {
  matches: [],
  loading: false,
  error: null,
};

// Reducer
export default function fifaReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FIFA_MATCHES_REQUEST:
      return { 
        ...state, 
        loading: true, 
        error: null 
      };
    case FETCH_FIFA_MATCHES_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        matches: action.payload 
      };
    case FETCH_FIFA_MATCHES_FAILURE:
      return { 
        ...state, 
        loading: false, 
        error: action.payload 
      };
    default:
      return state;
  }
}